export default __webpack_public_path__ + "images/FGLOGO.eddeb474f7670f91591fc199dd7bc015.svg"